<div class="scad-drag-sidemenu ">
<div class="scad-title__semi-bold mb-4">Select</div>
<div class="scad-title__sm-label">Keep the columns you want to include in the next step of the pipeline selected; only these columns will be considered.
</div>

<div class="scad-checkbox mt-4 mb-3" *ngIf="_fb.activeNode?.reFormat?.length>0">
    <input type="checkbox" id="selectall"  (click)="updateAllCheckbox()" [(ngModel)]="isCheckedAll" name="selectall" value="selectall">
    <label class="scad-title__sm-label-sub" for="selectall">Select All</label>
</div>
<div class="select-item">

   <div *ngFor="let item of _fb.activeNode.reFormat;let i=index" class="select-item__field" >
      <div class="select-item__header" >
          <div class="select-item__field-label">
              <svg  xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
                  <circle cx="7.3291" cy="4.3291" r="1.3291" fill="#6A7180"/>
                  <circle cx="7.3291" cy="10.7847" r="1.3291" fill="#6A7180"/>
                  <circle cx="7.3291" cy="17.2402" r="1.3291" fill="#6A7180"/>
                  <circle cx="13.7847" cy="4.3291" r="1.3291" fill="#6A7180"/>
                  <circle cx="13.7847" cy="10.7847" r="1.3291" fill="#6A7180"/>
                  <circle cx="13.7847" cy="17.2402" r="1.3291" fill="#6A7180"/>
              </svg>
              <div class="scad-checkbox scad-checkbox__small-check" *ngIf="_fb.activeNode?.reFormat?.length>0" (click)="updateCheckbox(i)">
                <input type="checkbox"    [checked]="item.checked" >
                <label class="scad-title__sm-label-sub" >   {{item.originalName}} </label>
              </div>
          </div>
          <div class="select-item__down-arrow" (click)="itemCollaps(i)">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.66675 6.6665L9.93336 13.3332L15.1429 6.6665" stroke="#364151" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

          </div>
      </div>

    <div class="select-item__sub-body" [ngClass]="{'item-remove': (item.isCheck === false || item.isCheck === undefined)}">
      <div class="pb-3">
        <div class="scad-title__sm-thin-gray mt-3 mb-3">Rename Column</div>
        <div class="scad-input">
          <input type="text" class="scad-input-half" [(ngModel)]="item.updatedName" placeholder="Enter Here"  />
        </div>
      </div>

      <div class="d-flex pb-3">
        <div class="scad-title__sm-thin-gray"> Data Type </div>
        <div class="scad-title__sm-label-sub ps-2">String</div>
      </div>

      <div class="pb-3">
        <div class="scad-title__sm-thin-gray mb-3">Change Data Type</div>
        <div class="sh-input">
          <ng-select class="shNgclass ng-select-default"  [items]="cities" bindLabel="name" placeholder="Select" [(ngModel)]="selectedCity"> </ng-select>
        </div>
      </div>

    </div>
    <!-- <div class="pb-3">
      <div class="pb-2 scad-title__sm-thin-gray"> Visualization Title</div>
      <div class="scad-input" >
        <input class="sh-input-text" type="text"  placeholder="Title Here.." >
      </div>
    </div> -->
   </div>

</div>

<div *ngIf="_fb.activeNode?.reFormat?.length>0">
  <div class="scad-checkbox mt-4 mb-2" (click)="selectRecords = !selectRecords">
    <input type="checkbox"  [checked]="selectRecords">
    <label class="scad-title__sm-label-sub" >Select Records</label>
  </div>
    <div class="select-record">
      <div class="left">
          <div class="scad-input" >
            <input class="sh-input-text" type="text" placeholder="Title Here.." value="800">
          </div>
      </div>
      <div class="right">
          <div class="sh-input">
            <ng-select class="shNgclass ng-select-default" [items]="selectTypes" bindLabel="name" placeholder="Select"> </ng-select>
          </div>
      </div>
    </div>
</div>

</div>
